import React from 'react';
import { IconMoodSad, IconSparkles } from '@tabler/icons-react';
const beforeItems = ['Cerchi un operatore disponibile ogni volta', 'Lo coordini via WhatsApp o telefono', 'Speri che arrivi puntuale', 'Paghi il prezzo pieno, da solo', 'Se cancella, sei da solo'];
const afterItems = ['Il cleaner è già assegnato in automatico', 'Zero messaggi, zero telefonate', 'Arriva puntuale — è già in zona', 'Costi ridotti, condivisi con host vicini', 'Sostituto automatico se serve'];
export function NeighborhoodMap() {
  return <div className="w-full bg-white py-20 md:py-24 px-5 space-y-[10px] pt-[80px] pb-[80px]" data-id="element-169">
      <div className="max-w-6xl mx-auto" data-id="element-170">
        {/* Centered heading */}
        <div className="text-center mb-12" data-id="element-171">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy" data-id="element-172">
            Cos'è <span className="text-[#FF4080]" data-id="element-173">CleanAI</span>?
          </h2>
          <p className="font-body text-body-gray text-base md:text-lg mt-3 max-w-2xl mx-auto leading-relaxed" data-id="element-174">
            Un modello di sharing degli interventi di pulizia e manutenzione tra
            host della stessa zona. Meno costi per gli host. Più opportunità per
            i professionisti.
          </p>
        </div>

        {/* Before / After comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-175">
          {/* BEFORE */}
          <div className="border-2 border-gray-200 rounded-none p-7" data-id="element-176">
            <p className="font-heading font-bold text-sm uppercase tracking-widest mb-6 flex items-center gap-2" style={{
            color: '#9CA3AF'
          }} data-id="element-177">
              <IconMoodSad size={18} stroke={1.5} data-id="element-178" />
              Senza CleanAI
            </p>
            <ul className="space-y-4" data-id="element-179">
              {beforeItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-180">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5 text-xs font-bold" style={{
                background: '#FEE2E2',
                color: '#EF4444'
              }} data-id="element-181">
                    ✕
                  </span>
                  <span className="font-body text-body-gray text-sm md:text-base leading-relaxed" data-id="element-182">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="border-2 rounded-none p-7" style={{
          borderColor: '#002ca5'
        }} data-id="element-183">
            <p className="font-heading font-bold text-sm uppercase tracking-widest mb-6 flex items-center gap-2 text-[#002CA5]" data-id="element-184">
              <IconSparkles size={18} stroke={1.5} data-id="element-185" />
              Con CleanAI
            </p>
            <ul className="space-y-4" data-id="element-186">
              {afterItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-187">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center mt-0.5 text-xs font-bold" style={{
                background: '#D1FAE5',
                color: '#059669'
              }} data-id="element-188">
                    ✓
                  </span>
                  <span className="font-body text-navy text-sm md:text-base leading-relaxed" data-id="element-189">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Callout */}
        <div className="mt-8 text-center" data-id="element-190">
          <p className="font-body text-sm md:text-[15px] text-body-gray leading-relaxed" data-id="element-191">
            Tu apri l'app e trovi tutto fatto. Il resto lo gestisce CleanAI.
          </p>
        </div>
      </div>
    </div>;
}